
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/news-events",
      function () {
        return require("private-next-pages/about-us/news-events/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/news-events"])
      });
    }
  